import { useQuery } from '@tanstack/react-query';
import { consoleApi } from '../api/client';
import { QueryState } from '../components/QueryState';
import { PageHeader } from '../components/Shell';
import { useRouter } from '../lib/router';

export function PreviewsPage() {
  const { search, navigate } = useRouter();
  const gallery = useQuery({ queryKey: ['private-previews'], queryFn: consoleApi.previews });
  const selected = new URLSearchParams(search).get('id') ?? gallery.data?.items[0]?.id;
  const detail = useQuery({
    queryKey: ['private-preview', selected],
    queryFn: () => consoleApi.preview(selected!),
    enabled: !!selected,
    retry: false
  });
  const preview = detail.data;
  const image = preview ? `data:${preview.mime_type};base64,${preview.content_base64}` : '';

  return <>
    <PageHeader title="Preview gallery" description="Private concepts for review. Viewing or downloading a preview does not send email or add it to outreach." />
    <QueryState loading={gallery.isLoading} error={gallery.isError} retry={() => void gallery.refetch()}>
      {!gallery.data?.items.length && !selected ? <section className="state-panel">No previews have been added yet. Review images will appear here when available.</section> : <>
        <label className="preview-picker"><span>Choose a preview</span>
          <select value={selected ?? ''} onChange={event => navigate(`/previews?id=${encodeURIComponent(event.target.value)}`)}>
            {selected && !gallery.data?.items.some(item => item.id === selected) ? <option value={selected}>Requested preview</option> : null}
            {gallery.data?.items.map(item => <option key={item.id} value={item.id}>{item.title}</option>)}
          </select>
        </label>
        <QueryState loading={detail.isLoading} error={false}>
          {detail.isError ? <div className="state-panel state-panel--error" role="alert">This preview could not be loaded. Choose another preview or try again.<button className="button button--quiet" type="button" onClick={() => void detail.refetch()}>Try again</button></div> : null}
          {preview ? <section className="private-preview" aria-labelledby="preview-title">
            <div className="section-heading"><div><h2 id="preview-title">{preview.title}</h2><p>{preview.description}</p></div></div>
            <figure className="concept-preview">
              <img src={image} alt={preview.description} width={preview.width} height={preview.height} />
              <figcaption><span>{preview.width} × {preview.height} px</span><a href={image} download={`${preview.id}.${preview.mime_type === 'image/jpeg' ? 'jpg' : 'png'}`}>Download image</a></figcaption>
            </figure>
          </section> : null}
        </QueryState>
      </>}
    </QueryState>
  </>;
}
